<section *ngIf="isLocalEnvironment" class="d-flex justify-content-center align-items-center landingpage-placeholder px-5">
    <p class="text-center">
        When the application is deployed, you should see the
        <a href="https://template-3c092c.webflow.io/" target="_blank" rel="noopener" class="caption">Webflow Landingpage</a> here.
    </p>
</section>
